<template>
  <div class="banner-plan">
		<div class="banner-plan-header" :class="{scrolling: scrolled}">
			<v-layout>
				<v-flex xs5>
					<img src="/static/images-new/logos/logo-casamarket.svg" alt="logo" class="img-header">
				</v-flex>
				<v-flex xs7 text-xs-right>
					<button class="btn-header" @click="openModal">Quiero tener mi tienda Online <span class="w-semibold">Gratis</span></button>
				</v-flex>
			</v-layout>
		</div>
		<v-layout class="banner-main-container" wrap>
			<v-flex class="center-mobile">
				<img src="/static/images-new/logos/logo-casamarket.svg" alt="logo" class="image-logo">
				<p class="newwarning--text text-image mb-0">Hacia la tranformación digital</p>
			</v-flex>
			<v-flex class="fs-20 w-semibold br-desktop" text-xs-right>
				<a href="#beneficios" class="white--text href-depressed">
					BENEFICIOS
				</a>
				<a href="#sobre-casamarket" class="white--text href-depressed ml-50">
					SOBRE CASAMARKET
				</a>
			</v-flex>
		</v-layout>
		<v-layout row wrap justify-space-between class="mt-content">
			<v-flex xs12 md6>
				<p class="w-semibold title-banner primary--text desktop">
					Tienda Online <br/> Gratis…. sí, leiste bien: <span class="text-orange w-bold">GRATIS!</span>
				<p>
				<p class="w-semibold title-banner primary--text mobile">
					TU tienda Online <span class="text-orange w-bold">GRATIS!</span>
				<p>
				<div class="mobile">
					<slider
						:speed="2000"
						:interval="20000"
						:stop-on-hover="true"
						animation="fade"
						height="368px"
					>
						<slider-item v-for="item in items" :key="item.id">
							<div>
								<div class="slider-btn" v-if="item.id === 1 || item.id === 2">
									<v-layout>
										<v-flex xs6 class="border-r" pr-1>
											<p class="bold-text mb-0">Tu tienda <br/> Online {{item.id === 1 ? 'Móvil' : 'Web'}}</p>
										</v-flex>
										<v-flex xs6 pl-3>
											<p class="mb-0">Recibe
												<span class="w-semibold">tus pedidos</span>
												 por Whatsapp
												 <img src="/static/images-new/icons/whatsapp-border-white.svg" height="17" class="ml-2">
											</p>
										</v-flex>
									</v-layout>
								</div>
								<div v-else-if="item.id === 5" class="slider-btn">
									<v-layout>
										<v-flex xs10>
											<p class="mb-0">Recibe <span class="w-semibold">tus pedidos</span> por Whatsapp con todo el detalle.</p>
										</v-flex>
										<v-flex xs2>
											<img src="/static/images-new/icons/whatsapp-border-white.svg" height="36">
										</v-flex>
									</v-layout>
								</div>
								<div
									v-else
									v-html="item.text" 
									class="slider-btn"
									:style="`width: ${item.width}`">
								</div>
								<div class="content-image-slider">
									<img 
										:src="item.image" 
										:alt="item.id"
										:height="item.id === 5? '265px' : 'auto'"
										class="image-slider"
									>
								</div>
							</div>
						</slider-item>
					</slider>
				</div>
				<v-flex text-xs-center class="mt-50 column-mobile desktop">
					<div class="content-banner" v-for="(item, index) in sectionBanners" :key="index">
						<div>
							<img src="/static/images-new/icons/check-orange.svg" height="25" width="25" alt="check">
						</div>
						<div class="ml-2 w-medium">{{ item.name }}</div>
					</div>
				</v-flex>
				<v-flex class="content-want">
					<v-btn
						class="btn-market ma-0 w-black btn-outline"
						color="orange"
						depressed
						@click="openModal"
					>
						Quiero tener mi tienda Online Gratis
					</v-btn>
				</v-flex>
				<p class="newwarning--text fs-14 text-banner w-medium">
					Regístrate y crea tu tienda online en 2 Pasos
				</p>
			</v-flex>
			<v-flex xs6 text-xs-right>
				<div class="br-desktop">
					<button @click="openModal"  class="link-wssp-banner w-bold">
						Vende en tu Tienda Online y recibe pedidos por WhatsApp
						<img src="/static/images-new/icons/whatsapp-border-white.svg" alt="icono-whatsapp" height="45" class="ml-2">
					</button>
				</div>
				<div class="br-desktop content-image">
					<img src="/static/images-new/sections/mano-banner-plan.png" alt="image-telefono" class="img-phone-banner">
				</div>
			</v-flex>
		</v-layout>
			<v-dialog
				v-model="dialog"
				persistent
				max-width="400"
				@keydown.esc="closeModal"
			>
			<v-card>
				<div class="container-iframe" v-show="!loading">
					<div class="container-close">
						<v-btn
							depressed
							flat
							icon
							@click="closeModal"
						>
							 <img src="/static/images-new/sections/close.svg" alt="cerrar" height="20">
						</v-btn>
					</div>
					<iframe 
						:src="linkPageIFrame" 
						style="border:0px #ffffff none;" 
						name="myiFrame" 
						scrolling="no"
						frameborder="1" 
						marginheight="0px" 
						marginwidth="0px" 
						height="600" 
						width="100%"
						allow="geolocation"
						allowfullscreen>
					</iframe>
				</div>
				<div v-show="loading" class="container-progrees">
					<v-progress-circular
					:size="70"
					:width="7"
					indeterminate
					color="teal darken-1">
				</v-progress-circular>
				</div>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
function openModal() {
	this.linkPageIFrame = 'https://casamarket.la/activa-tu-catalogo#formulario';
	this.dialog = true;
	setTimeout(() => { this.loading = false; }, 3000);
}

function closeModal() {
	this.dialog = false;
	this.loading = true;
	this.linkPageIFrame = '';
}

function created() {
	window.addEventListener('scroll', this.handleScroll);
}

function destroyed() {
	window.removeEventListener('scroll', this.handleScroll);
}

function handleScroll() {
	const bp = document.getElementsByClassName('banner-plan');
	const scrollHeight = (bp[0].scrollHeight - 108);
	this.scrolled = window.scrollY > scrollHeight;
}

function data() {
	return {
		loading: true,
		dialog: false,
		linkPageIFrame: '',
		sectionBanners: [
			{
				id: 1,
				name: 'Sin costo de implementación',
			},
			{
				id: 2,
				name: 'Sin costo por transacción',
			},
			{
				id: 3,
				name: 'Sin costo de renovación',
			},
		],
		items: [
			{
				id: 1,
				image: '/static/images-new/banners/slider-1-free.png',
				text: `<p class="mb-0 w-semibold">Tu tienda Online Movil</p>
							<img src="/static/images-new/icons/whatsapp-border-white.svg" height="36" class="ml-2">`,
				width: '55%',
			},
			{
				id: 2,
				image: '/static/images-new/banners/slider-2-free.png',
				text: `<p class="mb-0 w-semibold">Tu tienda Online Movil</p>
							<img src="/static/images-new/icons/whatsapp-border-white.svg" height="36" class="ml-2">`,
				width: '55%',
			},
			{
				id: 3,
				image: '/static/images-new/banners/slider-3-free.png',
				text: '<p class="mb-0 w-semibold">Múltiples <br>medios de pagos</p>',
				width: '55%',
			},
			{
				id: 4,
				image: '/static/images-new/banners/slider-4-free.png',
				text: `<p class="mb-0"><span class="w-semibold">¿Preocupado por el Delivery?</span><br>
					Con CasaMarket vende online y nuestros 
					aliados se encargan del reparto:</p>`,
				width: '80%',
			},
			{
				id: 5,
				image: '/static/images-new/sections/whatsapp.png',
				text: `<p class="mb-0"><span class="w-semibold">¿Preocupado por el Delivery?</span><br>
					Con CasaMarket vende online y nuestros 
					aliados se encargan del reparto:</p>`,
				width: '80%',
			},
		],
		scrolled: false,
	};
}

export default {
	name: 'banner-plan',
	data,
	created,
	destroyed,
	methods: {
		openModal,
		closeModal,
		handleScroll,
	},
};
</script>

<style lang="scss" scoped>
.banner-plan {
	background-color: white;
	padding: 25px 0 33px 0;
	
	@media (min-width: 936px) {
		background-image: url('/static/images-new/banners/BANNER.png');
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
		background-color: white;
		height: 900px;
		padding: 57px 8% 0 8%;
		position: relative;
	}

	@media (min-width: 1024px) {
		padding: 57px 10% 0 10%;
	}
}

.ml-50 {
	margin-left: 80px;
}

.title-banner {
	margin: 25px 0 0 0;
	font-size: 20px;
	text-align: center;

	@media (min-width: 936px) {
		font-size: 30px;
		margin-top: 50px;
		text-align: left;
	}
}

.content-banner {
	align-items: center;
	background-color: color(white);
	border-radius: 9px;
	box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.08);
	display: flex;
	font-size: 17px;
	margin-bottom: 14px;
	padding: 15px 45px 15px 30px;
	width: 384px;

	@media (max-width: 936px) {
		font-size: 14px;
		padding: 15px 33px 15px 25px;
		margin: 0 0 14px 0;
		max-width: 100%;
	}

	&:first-child {
		margin-left: 0 !important;
	}
}

.mt-50 {
	margin-top: 40px;
	display: flex;
	justify-content: center;
}

.text-banner {
	margin: 0 auto;
	max-width: 90%;
	text-align: center;

	@media (min-width: 936px) {
		margin-left: 9%;
		max-width: 590px;
		text-align: left;
	}
}

.btn-market {
	border-radius: 35.5px;
	color: color(white);
	font-size: 12px;
	height: 54px !important;
	padding: 0 20px;
	width: 80% !important;

	.btn__content {
		white-space: none !important;
	}
	
	@media (min-width: 936px) {
		font-size: 16px;
		height: 63px !important;
		margin-top: 25px !important;
		width: 389px !important;
	}
}

.column-mobile {
	align-items: flex-start;
	flex-direction: column;
}

.center-mobile {
	@media (max-width: 936px) {
		text-align: center;
	}
}

.fs-20 {
	@media (max-width: 936px) {
		font-size: 15px;
	}
}

.link-wssp-banner {
	border-radius: 27px;
	background-color: #02979b;
	color: white;
	font-size: 13px;
	padding: 10px 22px;
	opacity: 0.95;
	max-width: 280px;

	@media (min-width: 936px) {
		font-size: 22px;
		padding: 12px 35px;
		max-width: 465px;
	}
}

.btn-wssp-mobile {
	border-radius: 0 15px 15px 0;
	background-color: #02979b;
	color: white;
	font-size: 13px;
	padding: 11px 20px;
	position: absolute;
    left: 0;
	top: 230px;
    width: 280px;
}

.text-orange {
	color: color(newprimary);
}

.img-phone-banner-mobile {
	@media (min-width: 936px) {
		height: 69vw;	
	}

	position: relative;
	top: 39px;
}

.content-image {
	bottom: -7px;
	position: absolute;
	right: 9%;
}

.max-width-mobile {
	width: 100px;
}

.container-iframe {
	position: relative;

	.btn__content {
		background-color: white !important;
		box-shadow: -2px 4px 9px 0px rgba(0,0,0,0.14);
	}
}

.container-close {
	background-color: white !important;
	border-radius: 50%;
	box-shadow: -2px 4px 9px 0px rgba(0,0,0,0.14);
	position: absolute;
	right: 10px;
	top: 10px;
}

.container-progrees {
	align-items: center;
	display: flex;
	justify-content: center;
	height: 600px;
}

.text-image {
	font-size: 20px;

	@media (max-width: 936px) {
		font-size: 12px;
	}
}

.image-logo {
	height: 63px;

	@media (max-width: 936px) {
		height: 39px;
	}
}

.desktop {
	display: block;

	@media (max-width: 936px) {
		display: none;
	}
}

.mobile {
	display: none;

	@media (max-width: 936px) {
		display: block;
	}
}

.image-slider {
	max-width: 100%;
	max-height: 370px;
}

.slider-btn {
	background-color: color(primary);
	border-radius: 0 15px 15px 0;
	color: color(white);
	display: flex;
	max-width: 80%;
	padding: 13px;
}

.content-image-slider {
	align-items: center;
	display: flex;
	justify-content: center;
	height: 332px;
}

.content-want {
	text-align: left;

	@media (max-width: 936px) {
		text-align: center;
	}
}

.banner-plan-header {
	background-color: color(white);
	box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.05);
	display: none;
	padding: 20px 4%;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 200;

	&.scrolling {
		display: block;
	}
}

.img-header {
	height: 47px;

	@media (max-width: 936px) {
		height: 27px;
	}
}

.btn-header {
	background-color: color(newprimary);
	border-radius: 27px;
	color: color(white);
	text-transform: uppercase;
	padding: 10px 15px;

	@media (max-width: 936px) {
		font-size: 12px;
		padding: 8px;
	}
}

.bold-text {
	font-size: 16px;
	font-weight: 900;
}

.border-r {
	border-right: 1px solid color(white);
}
</style>


// WEBPACK FOOTER //
// src/components/home-new/banner-plan.vue